(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('Score', Score);

    Score.$inject = ['$resource', 'urls', 'httpMethods'];
    function Score($resource, urls, httpMethods) {
        return $resource(urls.score, { id: '@id' }, {
            getProfile: {
                url: urls.getScoringProfile,
                method: httpMethods.get,
                allowAnonymous: true
            },

            getHistory: {
                url: urls.scoreHistory,
                method: httpMethods.get,
                params: {
                    individualId: '@individualId'
                },
                allowAnonymous: true
            },
            getDeletedScores: {
                url: urls.getDeletedScores,
                method: httpMethods.get,
                params: {
                    individualId: '@individualId'
                }                
            },

            getScoreData: {
                url: urls.scoreData,
                method: httpMethods.get,
                params: {
                    individualId: '@individualId',
                    scoreId: '@scoreId'
                }
            },
            postScore: {
                url: urls.postScore,
                method: httpMethods.post
            },

            updateTeeTime: {
                url: urls.updateTeeTime,
                method: httpMethods.post
            },

            getUltimateScorecardFacilities: {
                url: urls.getUltimateScorecardFacilities,
                method: httpMethods.get,
                isArray: true
            },
            getUltimateScorecard: {
                url: urls.getUltimateScorecard,
                method: httpMethods.get
            },
            
            getHandicapCalculation: {
                url: urls.getHandicapCalculation,
                method: httpMethods.get,
                allowAnonymous: true
            },
            getHandicapCard: {
                url: urls.getHandicapCard,
                method: httpMethods.get,
                allowAnonymous: true
            },
            getScoreDetails: {
                url: urls.getScoreDetails,
                method: httpMethods.get
            }
        });
    }
})();